export default "__VITE_ASSET__BTrvD3As__"